module.exports = __webpack_public_path__ + "static/img/taxi-request.38867fd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/holataxi/img/taxi-request.png
// module id = HtxJ
// module chunks = 1